export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";